export const HOME = "/";
export const HOTPOT_GUIDELINE = "/hotpot-guideline";
export const HOTPOT_SELECT_SOUP = "/hotpot-select-soup";
export const KICHI_HOTPOT_SELECT_SOUP = "/kichi-hotpot-select-soup";
export const PRODUCTS = "/products";
export const GROUP_BOOKING_INFO = "/group-booking-info";
